// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sortable .sortable__item {
  position: relative;
  display: flex;
}
.sortable__fallback {
  visibility: hidden;
}
.on-drag {
  cursor: move;
}
.on-drag .sortable__item > * {
  pointer-events: none;
}
.on-drag .sortable__filter:not(.sortable__item_placeholder) {
  pointer-events: none;
}
.on-drag .sortable__fallback {
  visibility: visible;
}
.on-drag .sortable__remove {
  opacity: 1 !important;
  background: transparent;
}
.on-drag .sortable__remove > * {
  opacity: 0.8;
}
.on-drag .sortable__remove:before {
  content: 'Remove';
  top: -3.5rem;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  width: auto;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.24), 0 0 2px 0 rgba(0,0,0,0.12);
  border: solid 0.084rem #dce1e5;
  border-radius: 0.333em;
  padding: 0.501rem 1.334rem;
  line-height: 1.715;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.on-drag .sortable__remove:before:has(a:focus-visible) {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
}
.on-drag .sortable__remove:before:has(a:focus-visible) a:focus-visible {
  outline: none;
  box-shadow: none;
}
.on-drag body {
  pointer-events: none;
}
.sortable.sortable.sortable__list {
  pointer-events: all;
}
.sortable.sortable.sortable__list_horizontal {
  display: flex;
}
.sortable.sortable.sortable__list_horizontal.sortable__list_moving .sortable__ghost {
  width: 4px;
  margin-right: -4px;
}
.sortable.sortable.sortable__list_vertical.sortable__list_moving .sortable__ghost {
  height: 4px;
  margin-bottom: -4px;
}
.sortable.sortable.sortable__list_moving .sortable__clone {
  display: flex !important;
}
.sortable.sortable.sortable__list_moving .sortable__ghost {
  border: none;
  position: relative;
  z-index: 1;
  overflow: hidden;
  color: transparent;
}
.sortable.sortable.sortable__list_moving .sortable__ghost:not(.sortable__ghost_highlighted) {
  background: transparent;
}
.sortable.sortable.sortable__list_moving .sortable__ghost > * {
  display: none !important;
}
.sortable.sortable.sortable__list_moving .sortable__clone + .sortable__ghost,
.sortable.sortable.sortable__list_moving .sortable__clone_before + .sortable__ghost {
  background: transparent;
}
.sortable.sortable.sortable__list_moving.sortable__list_single .sortable__ghost {
  background: transparent;
}
.sortable.sortable.sortable__list_empty {
  position: relative;
}
.sortable.sortable.sortable__list_empty.sortable__list_moving .sortable__ghost {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #e88f36;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
